/*
 * Dónde abrir una lista desplegable (sugerencias, combobox) para que no se
 * salga del contenedor con scroll que la rodea (p. ej. el panel de un modal)
 * y no cree un scroll nuevo mientras está abierta.
 */

/* Contenedor con scroll más cercano; null si no hay (se usa la ventana). */
export function contenedorConScroll(el) {
  let nodo = el?.parentElement
  while (nodo && nodo !== document.body) {
    const { overflowY } = getComputedStyle(nodo)
    if (overflowY === 'auto' || overflowY === 'scroll') return nodo
    nodo = nodo.parentElement
  }
  return null
}

/*
 * Lado y alto máximo para una lista de `altoDeseado` px pegada a `el`.
 * Abre hacia arriba si abajo no cabe y arriba hay más espacio; en cualquier
 * caso limita el alto al espacio disponible (la lista hace scroll interno)
 * para que el contenedor no la recorte. `margen` = separación + respiro.
 */
export function posicionLista(el, altoDeseado, margen = 14) {
  if (!el) return { arriba: false, altoMaximo: altoDeseado }
  const caja = el.getBoundingClientRect()
  const contenedor = contenedorConScroll(el)
  const limite = contenedor ? Math.min(window.innerHeight, contenedor.getBoundingClientRect().bottom) : window.innerHeight
  const techo = contenedor ? Math.max(0, contenedor.getBoundingClientRect().top) : 0
  const abajo = limite - caja.bottom - margen
  const arribaDisponible = caja.top - techo - margen
  const arriba = abajo < altoDeseado && arribaDisponible > abajo
  const espacio = arriba ? arribaDisponible : abajo
  return { arriba, altoMaximo: Math.max(80, Math.min(altoDeseado, espacio)) }
}
